import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-[16px] pl-[30px] pr-[24px] flex flex-col" }
const _hoisted_2 = { class: "flex justify-center items-center" }
const _hoisted_3 = { class: "flex items-center w-full justify-between max-w-[1624px]" }
const _hoisted_4 = { class: "font-gordita-medium text-[26px] text-Text/text_high" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center w-full justify-between max-w-[1624px] flex-col m-auto"
}

import UserNotifications from '@/components/common/userNotifications/userNotifications.vue';
import { isFeatureOn } from '@/views/Layout/Layout.utils';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'layout-header',
  props: {
    title: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(__props.title), 1),
            _withDirectives(_createVNode(UserNotifications, null, null, 512), [
              [_vShow, _unref(isFeatureOn)('NOTIFICATIONS')]
            ])
          ])
        ]),
        (_ctx.$slots.default)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "default")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }))
}
}

})